var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.369832 5.34761L5.53221 0.185324C5.65161 0.0658301 5.811 0 5.98095 0C6.1509 0 6.31029 0.0658301 6.42969 0.185324L6.80987 0.565403C7.05725 0.813068 7.05725 1.21559 6.80987 1.46288L2.47489 5.79786L6.81468 10.1376C6.93408 10.2571 7 10.4164 7 10.5863C7 10.7563 6.93408 10.9156 6.81468 11.0352L6.4345 11.4152C6.31501 11.5347 6.15571 11.6005 5.98576 11.6005C5.81581 11.6005 5.65642 11.5347 5.53702 11.4152L0.369832 6.2482C0.25015 6.12833 0.184414 5.96828 0.184792 5.79814C0.184414 5.62734 0.25015 5.46739 0.369832 5.34761Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.1544f8ab36d36d9a2d1710947682036b.svg";
export { ForwardRef as ReactComponent };